export const USER_GUIDE_DOC_KEYS = [
    "gameCreation",
    "lessonSequence",
    "liveDashboard",
    "livePerformance",
] as const;

export type UserGuideDocKey = (typeof USER_GUIDE_DOC_KEYS)[number];

export const USER_GUIDE_PDF_PATHS: Record<UserGuideDocKey, string> = {
    gameCreation: "/docs/user-guide/game-creation.pdf",
    lessonSequence: "/docs/user-guide/lesson-sequence.pdf",
    liveDashboard: "/docs/user-guide/live-dashboard.pdf",
    livePerformance: "/docs/user-guide/live-performance.pdf",
};
